const STORAGE_KEY = 'aliyah_commande_v1';

/** Champs texte du checkout, persistés tels quels — jamais les infos de carte
 * (gérées par l'élément Stripe, hors DOM/JS, jamais accessibles ni stockables). */
export interface SavedCommandeFields {
  email?: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  addressComplement?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  phone?: string;
}

export function getSavedCommande(): SavedCommandeFields {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? (parsed as SavedCommandeFields) : {};
  } catch {
    return {};
  }
}

export function saveCommandeField(key: keyof SavedCommandeFields, value: string): void {
  try {
    const current = getSavedCommande();
    current[key] = value;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
  } catch {
    // localStorage indisponible (navigation privée, quota…) — tant pis, pas de
    // persistance cette fois, sans bloquer la saisie.
  }
}

/** À appeler une fois la commande réellement passée (redirection vers la
 * confirmation) — sinon une prochaine commande se préremplirait avec les
 * anciennes infos. */
export function clearSavedCommande(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // idem
  }
}
